<template>
  <div class="card card-map">
    <div class="content" >
      <div
          class="main_filters"
          :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
          @click="toggleFiltersState"
      >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
        <span class="main_fiters_toggler_text">
          {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
        </span>
      </div>

      <div class="row" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="wrap">
          <div class="line">
            <div class="flex-item select">
              <label> {{ translate('gps_track.source') }} </label>
              <tree-select
                  :options="data_source"
                  :multiple="false"
                  v-model="source"
                  :placeholder="translate('gps_track.source')"
                  :clearable="false"
              />
            </div>

            <div class="flex-item select">
              <label> {{ translate('gps_track.add_params.title') }} </label>
              <tree-select
                  :options="params_list"
                  :multiple="true"
                  v-model="add_params"
                  :placeholder="translate('gps_track.add_params.title')"
                  :clearable="false"
              />
            </div>


            <div class="flex-item datetime">
              <span class="form-group">
                <WrapDatePicker
                  v-model="datetime"
                  type="datetime"
                  :range="true"
                  value_type="X"
                  :confirm="true"
                  :clearable="false"
                  :disabled_date="['- 24 months', 'now']"
                  :placeholder="translate('gps_track.period')"
                  :label="translate('gps_track.period')"
                />
              </span>
            </div>

            <div class="flex-item datetime">
              <fg-input
                  type="number"
                  :min=0
                  :max=3600
                  v-model="interval"
                  :placeholder="translate('gps_track.interval_placeholder')"
                  :label="translate('gps_track.interval_label')"
              />
            </div>
          </div>

          <div class="line">


            <div class="filter checkbox">
              <div class="info">
                {{ translate('gps_track.correct_position') }}
              </div>
              <label class="switch" @click.prevent="correct_position = !correct_position">
                <input type="checkbox" v-model="correct_position">
                <span class="slider round"></span>
              </label>
            </div>

            <div class="filter checkbox">
              <div class="info">
                {{ translate('gps_track.show_info_polyline') }}
              </div>
              <label class="switch" @click.prevent="show_info_polyline = !show_info_polyline">
                <input type="checkbox" v-model="show_info_polyline">
                <span class="slider round"></span>
              </label>
            </div>

            <div class="filter checkbox" v-if="$store.getters.getPermissions.permissionGod === true">
              <div class="info">
                {{ translate('gps_track.real_time_mode') }}
              </div>
              <label class="switch" @click.prevent="real_time_mode = !real_time_mode">
                <input type="checkbox" v-model="real_time_mode">
                <span class="slider round"></span>
              </label>
            </div>
          </div>

        </div>

        <div class="buttons">
          <router-link
              class="add_btn arrow"
              :to="'/device/' + $route.params.device_id + '/stats?&simcard_status=true&ts_start='+datetime[0]+'&ts_end='+datetime[1]"
              v-if="$store.getters.getPermissions?.viewDeviceStats === true"
              title="Statistics"
          >
            <span class="mdi mdi-chart-bar" />
          </router-link>

          <span
              class="mdi btn btn-info btn-apply"
              @click.prevent="showTrack"
          >
            {{ translate('gps_track.show_btn_track')}}
          </span>
        </div>
      </div>
    </div>

    <div class="gmap">
      <div class="online_stats" v-if="this.$store.getters.getPermissions.permissionGod === true">
        <template v-for="(value, key) in online_stats">
          <p v-if="key === 'online'">
            {{ key }}:  {{ uptimeToStr(value) }}
          </p>
          <p v-else>
            {{ key }}:  {{ value }}
          </p>
        </template>
      </div>

      <gmap-map
          :zoom="9"
          :center="center"
          :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
          class="main_map"
          :class="filters_state ? '' : 'all_map'"
          @click="click_find_distance"
          @rightclick="rightclick_find_distance"
        >

        <gmap-marker
            v-for="(marker, index) in distance_markers"
            :key="'distance'+index"
            :position="marker"
            :icon="{ url: require('assets/icons/sistematics_dist.png')}"
            :draggable="false"
        />

        <gmap-polyline
            :path="distance_markers"
            :coords.sync="distance_markers"
            :options="{
          strokeColor:'#7f058f',
          strokeOpacity: 1.0,
          strokeWeight: 3,
          icons: [{
            icon: {
              path: 0,
              scale: 3
            },
            offset: '1',
            repeat: '100px'
          }]
        }"
        />

        <gmap-info-window
            :options="{
          maxWidth: 300,
          pixelOffset: {
            width: 0,
            height: -10
          },
          content: distanceInfo,
          strokeColor:'#FF0000'
        }"
            :position="distancePos"
            :opened="distanceOpen"
            @closeclick="clear_find_distance()"
        >
        </gmap-info-window>

        <gmap-marker
            v-for="(item,index) in all_coords"
            :key="index"
            :position="item"
            :icon="coord_icon(index, item)"
            :clickable="true"
            :draggable="false"
            @click="openInfoWindow(item, 'first')"
            @rightclick="openInfoWindow(item, 'second')"
            @dblclick="copy_to_clipboard(item.lat + ' ' + item.lng)"
        />

        <gmap-polyline
            v-for="(polyline, index) in all_polyline"
            :key="polyline[polyline.length - 1].ts"
            :path="polyline"
            :options="{
            strokeColor:'#000000',
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [{
              icon: {
                path: 1,
                scale: 2
              }
            }]
          }"
        />

        <gmap-info-window
            v-for="(polyline, index) in info_all_polyline"
            :key="polyline.ts + '' + index"
            :options="{
            maxWidth: 300,
            pixelOffset: {
              width: 0,
              height: -35
            },
            content: get_date(polyline.ts),
            strokeColor:'#FF0000'
          }"
            :position="polyline"
            :opened="show_info_polyline"
        >
        </gmap-info-window>

        <gmap-info-window
            :options="{maxWidth: 300, pixelOffset: {width: 0, height: -35}, content: this.info, strokeColor:'#FF0000'}"
            :position="infoWinPos"
            :opened="infoBoxOpen"
            @closeclick="infoBoxOpen=false"
        >
        </gmap-info-window>

        <gmap-marker
            v-for="(item,index) in real_time_coords_comp"
            :key="item.lat + item.lng + index"
            :position="item"
            :icon="real_time_coords_icon(index, item)"
            :clickable="true"
            :draggable="false"
            @click="openInfoWindow(item, 'first')"
            @rightclick="openInfoWindow(item, 'second')"
            @dblclick="copy_to_clipboard(item.lat + ' ' + item.lng)"
        />

        <gmap-polyline
            :path="real_time_coords_comp"
            :options="{
            strokeColor:'#2745c9',
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [{
              icon: {
                path: 1,
                scale: 2
              }
            }]
          }"
        />

      </gmap-map>
    </div>
  </div>
</template>

<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'Maps',
  components:{
    WrapDatePicker
  },
  props: ['dev_fid', 'dev_id', 'swarm', 'lora'],
  data () {
    let today = new Date().setHours(0, 0, 0, 0)
    let ts_start = (new Date(today).setDate(new Date(today).getDate()) / 1000).toString()
    let ts_end = (new Date(today).setHours(23, 59, 59, 0) / 1000).toString()

    return {
      info: '',
      infoBoxOpen: false,
      infoWinPos: {lat: 0, lng:0},
      all_coords:[],
      all_polyline:[],
      info_all_polyline: [],
      show_info_polyline: true,
      interval: null,
      datetime:[ts_start, ts_end],
      center:{lat: 56.011755, lng:92.875629},
      show_last_position: true,
      show_last_info: true,

      distanceInfo: '',
      distanceOpen: false,
      distancePos: {lat: 0, lng:0},
      start_find: false,
      distance_markers: [],
      source: 'gps',
      add_params: ['online_status'],
      correct_position: true,

      filters_state: true,

      real_time_coords:[],
      real_time_mode: false,

      online_stats: {}
    }
  },
  mounted(){
    // this.$store.dispatch("WS_Subscribe",{ topic: `device_gps.${this.dev_id}`, func: this.ParseDeviceMonitor})
    this.check_query()
    this.showTrack()
  },
  activated() {
    // this.$store.dispatch("WS_Subscribe",{ topic: `device_gps.${this.dev_id}`, func: this.ParseDeviceMonitor})
    this.check_query()
  },
  destroyed() {
    this.$store.dispatch("WS_Unsubscribe",`device_gps.${this.dev_id}`)
  },
  watch:{
    cur_id () {
      this.showTrack()
    },
    real_time_mode:{
      handler(new_val){
        if (new_val){
          this.$store.dispatch("WS_Subscribe",{ topic: `device_gps.${this.dev_id}`, func: this.ParseDeviceMonitor})
        }else {
          this.$store.dispatch("WS_Unsubscribe",`device_gps.${this.dev_id}`)
        }
      }
    },
    datetime: {
      handler(){
        let string = '?ts_start=' + this.datetime[0] + '&ts_end=' + this.datetime[1]
        history.pushState(null, null, this.$route.path + string)
      }
    },
  },
  computed:{
    real_time_coords_comp(){
      return this.real_time_coords
    },
    data_source() {
      let list = [
        {id: 'all', label: 'All'},
        {id: 'gps', label: 'GPS'},
        {id: 'cell', label: 'CellID'}
      ]
      if (this.swarm !== null){
        list.push({id: 'swarm', label: 'Swarm'})
      }
      if (this.lora !== null){
        list.push({id: 'lora', label: 'LoRa'})
      }
      if (this.iridium !== null){
        list.push({id: 'iridium', label: 'IRIDIUM'})
      }
      return list
    },
    params_list(){
      return [
        {id: 'online_status', label: this.translate('gps_track.add_params.status') },
        {id: 'speed', label: this.translate('gps_track.add_params.speed') },
        {id: 'altitude', label: this.translate('gps_track.add_params.altitude') },
        {id: 'simcards_status', label: this.translate('gps_track.add_params.simcards') },
        {id: 'course', label: this.translate('gps_track.add_params.course') }
      ]
    },
    final_distance() {
      let lat1,lon1,lat2,lon2

      for (let marker of this.distance_markers) {
        if (marker.type === 'first') {
          lat1 = marker.lat
          lon1 = marker.lng
        }else if (marker.type === 'second') {
          lat2 = marker.lat
          lon2 = marker.lng
        }
      }
      return this.distance_calculation(lat1,lon1,lat2,lon2)
    },
    cur_id () { return this.$route.params.device_id },
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    }
  },

  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        if (this.$route.query.ts_start && this.$route.query.ts_end){
          this.datetime = [this.$route.query.ts_start, this.$route.query.ts_end]
        }else{
          this.datetime = [ts_start, ts_end]
        }

      }
    },
    uptimeToStr(timeUp) {
      let str = "";

      let days = Math.floor(timeUp / 86400);

      if (days) {
        days = days < 10 ? ("0" + days).slice(-2) : days;
        str += days > 0 ? days + " " + this.translate("date.d") + " " : "";
      }

      let hours = Math.floor((timeUp % 86400) / 3600);
      if (hours) {
        str += ("0" + hours).slice(-2) + " " + this.translate("date.h") + " ";
      }

      if (!days || hours === 0) {
        let min = Math.floor((timeUp % 3600) / 60);
        str += ("0" + min).slice(-2) + " " + this.translate("date.min") + " ";
      }

      if (!days && !hours) {
        let sec = Math.floor(timeUp % 60);
        str += ("0" + sec).slice(-2) + " " + this.translate("date.sec") + " ";
      }

      return str;
    },
    ParseDeviceMonitor(cmd) {
      if(!Array.isArray(cmd.data)){
        let data = {}
        Object.keys(cmd.data).forEach((index) => {
          data[index] = Number(cmd.data[index])
        })
        data.lng = data.long
        this.real_time_coords.push(data)
        this.center = {
          "lat": data.lat,
          "lng": data.lng
        }
        // this.device_monitor = Object.assign(this.device_monitor, cmd.data)
      }
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
    },
    distance_calculation(lat1,lon1,lat2,lon2){
      let R = 6371000; // Radius of the earth in m
      let dLat = this.deg2rad(lat2-lat1);  // deg2rad below
      let dLon = this.deg2rad(lon2-lon1);
      let a =
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon/2) * Math.sin(dLon/2)
      ;
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      let d = R * c; // Distance in m

      return Math.trunc(d)
    },
    // map_get_date(item){
    //   return this.get_date(item)
    // },
    coord_icon(index, item){
      if (index !== this.all_coords.length-1){
        return {
          path: 0,
          scale: 3,
          strokeColor: item.online === undefined ? 'black' : item.online ? 'green': 'red',
          fillColor: '',
          fillOpacity: 0
        }
      }else{
        let interval = (this.interval === '' || this.interval === null) ? 300 * 1000 : +this.interval*1000
        let one_hour_ms = 60*60*1000

        if (item && (item.ts*1000 + one_hour_ms + interval) < new Date().getTime()){
          return { url: require('assets/icons/sistematics_offline.png')}
        }else{
          return { url: require('assets/icons/sistematics_online.png')}
        }
      }
    },
    real_time_coords_icon(index, item){
      if (index !== this.real_time_coords.length - 1){
        return {
          path: 0,
          scale: 3,
          strokeColor: '#2745c9',
          fillColor: '#2745c9',
          fillOpacity: 0
        }
      }else{
        return { url: require('assets/icons/icon_bus.png')}
      }
    },
    deg2rad(deg) {
      return deg * (Math.PI/180)
    },
    clear_find_distance(){
      this.distanceOpen = false
      this.distance_markers = []
    },
    click_find_distance(event){
      if (event.domEvent.ctrlKey) this.add_distance({lat: event.latLng.lat(), lng: event.latLng.lng()}, "first")
    },
    rightclick_find_distance(event){
      if (event.domEvent.ctrlKey) this.add_distance({lat: event.latLng.lat(), lng: event.latLng.lng()}, "second")
    },
    add_distance(elem, type){
      this.distance_markers = this.distance_markers.filter((elem) => {
        if (elem.type !== type) return elem
      })

      let coord = {
        lat: elem.lat,
        lng: elem.lng,
        type: type
      }
      this.distance_markers.push(coord)

      this.openInfoWindowDistance(coord)
    },
    showTrack () {
      if (this.$route.params.device_section === 'tracking') {
        this.infoBoxOpen = false
        this.all_coords = []

        if (this.datetime.length === 0) {
          this.global_notify('info', this.translate('gps_track.select_date_range'))
          return
        }

        this.real_time_coords = []
        this.info_all_polyline = []

        if (this.$route.name === 'device_section'){

          let params = {
            "interval": (this.interval === '' || this.interval === null) ? null : +this.interval,
            "correct_position": this.correct_position,
            "start": +this.datetime[0],
            "end": +this.datetime[1],
            "show_last_position": this.show_last_position,
            "source": this.source,
            "add_params": this.add_params
          }

          this.$http.v1.getDeviceTrack(this.dev_fid, params,(response) => {
            this.show_last_position = false

            if(response.data?.track?.length > 0) {
              if (response.data.has_correct_position === true) {
                this.global_notify('info', this.translate('gps_track.has_correct_position'), 5000)
              }
              this.center = {...response.data.track[response.data.track.length - 1]}

              this.all_coords = response.data.track
              this.all_polyline = response.data.new_track
              this.online_stats = response.data.online_stats

              if (response.data.new_track.length > 1){
                response.data.new_track.forEach((line) => {
                  let first = line[0]
                  let second = line[line.length - 1]
                  this.info_all_polyline.push(second)

                  if (this.distance_calculation(first.lat,first.long,second.lat,second.long) / 1000 > 100){
                    this.info_all_polyline.push(first)
                  }
                })
              }

              if (this.show_last_info) {
                this.openInfoWindow(response.data.track[response.data.track.length - 1])
                this.show_last_info = false
              }
            }else{
              this.all_coords = []
              this.all_polyline = []
              this.info_all_polyline = []
              this.global_notify('warning', this.translate('no_data'))
            }
          })
        }
      }
    },
    openInfoWindow (item, type) {
      if (event.ctrlKey) this.add_distance({ lat: item.lat, lng: item.lng }, type)
      this.infoWinPos = item
      this.infoBoxOpen = true
      let status = this.get_date(item.ts) + '<br/>';

      if (item.state){
        for( let i in item.state) {
          status += item.state[i].slot + ' ' + item.state[i].mno + ' ' + item.state[i].signal + ' ' +  item.state[i].sig_lvl + '<br/>'
        }
      }

      if (item.speed){
        status += this.translate('gps_track.add_params.speed') + ": " + item.speed.toFixed(2) + '<br/>'
      }

      if (item.altitude){
        status += this.translate('gps_track.add_params.altitude') + ": " + item.altitude.toFixed(2) + '<br/>'
      }

      if (item.course){
        status += this.translate('gps_track.add_params.course') + ": " + item.course.toFixed(2) + '<br/>'
      }

      this.info = status
    },

    openInfoWindowDistance (item) {
      if (this.final_distance) {
        this.distancePos = item
        this.distanceOpen = true
        if (this.final_distance < 999) {
          this.distanceInfo = this.final_distance + ' м'
        }else if (this.final_distance > 4999) {
          this.distanceInfo = (this.final_distance/1000) .toFixed(1) + ' км.'
        }else{
          this.distanceInfo = (this.final_distance/1000).toFixed(2) + ' км.'
        }
      }
    },
  },
}

</script>

<style lang="scss">

  .buttonP {
    position: absolute;
    left: 10px;
    top: 8px;
  }

  .tracking-date-range{
    top: 8px;
    .mx-datepicker-range {
      min-width: 100%;
    }
    .mx-icon-calendar {
      display: none;
    }
  }

  .time-start-end {
    top: 8px;
    .mx-datepicker {
      width: 100%;
    }
    .mx-icon-calendar {
      display: none;
    }
  }
  .distance{
    &_wrap{
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      .btn{
        margin-right: 10px;
      }
      .form-group{
        margin: 0;
      }
    }
  }
  .card.card-map{
    height: calc(100% - 10px);
    margin-top: 10px;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    .content{
      height: auto;
      padding: 20px 10px 10px;

      &.p0{
        padding: 0;
      }

      .row {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin: 0;

        .wrap{
          width: 89.5%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;

          .line{
            display: flex;
            align-items: flex-end;
            margin-bottom: 10px;

            &:last-child{
              margin-bottom: 0;
            }

            & > *{
              flex: 1;
            }

            .filter{
              margin: 0;
            }
          }
        }
        .buttons{
          width: 9.5%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          .add_btn{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 13px;
            width: 40px;
            height: 40px;
            span{
              font-size: 20px;
              color: #333333;
            }
          }
          .btn-apply{
            padding: 8px 20px;
            width: 100%;
          }
        }

        .flex-item{
          width: 50%;
          padding: 0 2.5px;
          .form-group{
            margin-bottom: 0;
          }
          label{
            font-size: 15px;
            height: auto;
            line-height: 120%;
          }
        }
        &::before{
          content: none;
        }
        &::after{
          content: none;
        }
      }
    }
    .gmap{
      position: relative;
      width: 100%;
      flex: 10;
      .online_stats{
        position: absolute;
        left: -1px;
        top: 0;
        z-index: 10;
        background-color: #f8f8f8;
        padding: 5px 10px;
        border: 1px solid #ccc;
        border-radius: 0 0 3px 0;
        p{
          font-size: 14px;
          margin-bottom: 5px;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
      .main_map{
        width: auto;
        height: 100%;
        &.all_map{
          height: 100% ;
        }
      }
    }






  }

  @media (max-width:1200px) {
    .card.card-map{
      .content{
        height: 160px;
        .row {
          align-items: flex-end;
          .wrap{
            width: 79.5%;
            flex-wrap: wrap;
            margin-bottom: 10px;
            .flex-item{
              width: 49%;
            }
          }
          .btn-apply{
            width: 19.5%;
            margin: 10px 0;
          }
        }
      }
      .main_map{
        height: calc(100% - 160px);
      }
    }
  }
  @media (max-width:475px) {
    .card.card-map{
      .content{
        height: auto;
        .row {
          align-items: flex-end;
          flex-direction: column;
          .wrap{
            width: 100%;
            flex-direction: column;
            .flex-item{
              width: 100%;
            }
          }
          .btn-apply{
            width: 100%;
          }
        }
      }
      .main_map{
        height: calc(100% - 160px);
      }
    }
  }
</style>
